export enum UserRolesEnum {
  GLOBAL_ADMIN = 'global-admin',
}
